export class Mutex<T> {
  locked = false;
  waiting: ((params: T) => void)[] = [];

  private constructor(public readonly lockName: string) {}
  private static locks: { [key: string]: Mutex<unknown> } = {};

  public static getLock(lock: string) {
    if (!Mutex.locks[lock]) Mutex.locks[lock] = new Mutex(lock);
    return Mutex.locks[lock];
  }

  // Function to acquire the lock
  async lock(onlyWaitOne = false, returnErrorInsteadOfThrow = false) {
    const unlock = (param: T) => {
      // Unlock function to release the lock
      const next = this.waiting.shift();
      if (next) next(param);
      else this.locked = false;
    };

    // If already locked, queue the next lock attempt
    try {
      if (this.locked) {
        if (onlyWaitOne && this.waiting.length > 0) {
          const err: Error & { customCode?: string } = new Error('Already waiting for existing lock: ' + this.lockName);
          err.customCode = 'ALREADY_WAITING';
          throw err;
        }
        const previousParams = await new Promise<T>((resolve) => this.waiting.push(resolve));
        return {unlock, previousParams, error: null};
      } else {
        this.locked = true;
        return Promise.resolve({unlock, previousParams: null, error: null});
      }
    } catch (error) {
      if (returnErrorInsteadOfThrow) return {unlock: () => {}, error: error as Error};
      else throw error;
    }
  }
}
